import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={72} height={27} viewBox="0 0 72 27" fill="none" {...props}>
      <Path
        d="M36 27c-19.882 0-36-.224-36-.5s16.118-.5 36-.5 36 .224 36 .5-16.118.5-36 .5z"
        fill="#344B3F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.836 16.967v9.085h.215v-9.085h-.215z"
        fill="#3F3D56"
      />
      <Path
        d="M66.111 18.313a1.178 1.178 0 110-2.356 1.178 1.178 0 010 2.356z"
        fill="#EEFF87"
      />
      <Path d="M65.943 22.687s.188-4.144 4.038-3.662z" fill="#3F3D56" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.551 4.682v21.9h.215v-21.9h-.215z"
        fill="#344B3F"
      />
      <Path
        d="M38.659 6.365a1.682 1.682 0 110-3.365 1.682 1.682 0 010 3.365z"
        fill="#B0F3AA"
      />
      <Path d="M38.659 11.749s.25-5.275 5.384-4.661z" fill="#344B3F" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.575 1.682v24.9h.215v-24.9h-.215z"
        fill="#344B3F"
      />
      <Path
        d="M19.683 3.365a1.682 1.682 0 110-3.365 1.682 1.682 0 010 3.365z"
        fill="#EEFF87"
      />
      <Path d="M19.683 8.749s.25-5.275 5.383-4.661z" fill="#344B3F" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.491 15.682v11h-.214v-11h.214z"
        fill="#344B3F"
      />
      <Path
        d="M14.384 17.365a1.682 1.682 0 100-3.365 1.682 1.682 0 000 3.365z"
        fill="#B0F3AA"
      />
      <Path
        d="M14.384 22.749s-.25-5.274-5.384-4.662zM35.383 15.885c2.892 4.5 2.1 10.225 2.1 10.225S32 24.537 29.108 20.036c-2.892-4.5-2.1-10.225-2.1-10.225s5.482 1.573 8.374 6.074z"
        fill="#344B3F"
      />
      <Path
        d="M37.583 25.916s.071-.011.203-.037c.104-.021.249-.051.425-.093 1.576-.365 5.765-1.602 8.504-4.855C50.143 16.86 50 11.17 50 11.17s-5.242.84-8.696 4.496c-.15.158-.295.32-.436.489-2.983 3.543-3.262 8.311-3.284 9.49-.003.176 0 .272 0 .272z"
        fill="#00D77F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.136 9.752l.017.06.06-.01-.009-.07-.068.02zM37.489 26.11l.017.06-.069.019-.01-.07.062-.009zM48.1 9.891l.02.181c.016.164.036.405.05.707.03.605.04 1.458-.044 2.452-.166 1.988-.698 4.533-2.163 6.772-1.465 2.238-3.587 3.75-5.345 4.704a18.93 18.93 0 01-2.233 1.03 14.531 14.531 0 01-.844.293 14.502 14.502 0 01-.07-.888c-.03-.605-.039-1.458.044-2.452.166-1.988.699-4.533 2.164-6.771 1.464-2.239 3.586-3.751 5.344-4.704a18.93 18.93 0 012.234-1.03 14.54 14.54 0 01.843-.294zM37.49 26.11l-.061.009v-.002l-.001-.003-.002-.012a14.468 14.468 0 01-.078-.953c-.03-.61-.039-1.469.045-2.469.167-2 .703-4.567 2.183-6.83 1.48-2.261 3.621-3.786 5.39-4.744.884-.48 1.676-.818 2.247-1.037a14.658 14.658 0 01.92-.316l.003-.001.018.06.06-.01.001.002v.003l.002.013.006.05a14.586 14.586 0 01.072.904c.03.608.04 1.467-.044 2.467-.167 2-.703 4.567-2.184 6.83-1.48 2.261-3.62 3.786-5.389 4.744-.884.48-1.677.818-2.248 1.037a14.658 14.658 0 01-.859.299l-.048.014a1.25 1.25 0 01-.012.003l-.004.002-.002-.006-.015-.054z"
        fill="#3F3D56"
      />
      <Path
        d="M33.13 16.667c.236 5.305 4.298 9.443 4.298 9.443s3.678-4.462 3.441-9.767c-.236-5.304-4.297-9.442-4.297-9.442s-3.678 4.462-3.442 9.766z"
        fill="#00D77F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.55 7.097l.776 19.016.124-.005-.777-19.016-.123.005z"
        fill="#3F3D56"
      />
    </Svg>
  );
}

export default SvgComponent;
